export function hasSalesAccount(item) {
    var _ref;
    var _item_xero;
    return (_ref = (_item_xero = item.xero) === null || _item_xero === void 0 ? void 0 : _item_xero.hasSalesAccount) !== null && _ref !== void 0 ? _ref : false;
}
